import { lazy } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import Loadable from '../components/Loadable'
import CompactLayout from '../layouts/compact/CompactLayout'
import LoginRoutes from './LoginRoutes'
import MainRoutes from './MainRoutes'
import { MinimalLayout } from '../layouts/minimal'

const NotFound = Loadable(lazy(() => import('../pages/errors/Error404Page')))
const Forbidden = Loadable(lazy(() => import('../pages/errors/ForbiddenPage')))
const AvisoPrivacidadPage = Loadable(lazy(() => import('../pages/utils/AvisoPrivacidad')))

export default function ThemeRoutes() {
    return useRoutes([
        LoginRoutes, 
        MainRoutes,
        { 
          element: <MinimalLayout />,
          children: [
            { path: 'aviso_de_privacidad', element: <AvisoPrivacidadPage /> }
          ],
        },
        { 
          element: <CompactLayout />,
          children: [
            { path: '401', element: <Forbidden /> },
            { path: '404', element: <NotFound /> },
          ],
        },
        { path: '/', element: <Navigate to="/auth/login" replace /> },
        { path: '*', element: <Navigate to="/404" replace /> },
    ])
}
